export const DEFAULT_VEHICLE_GROUP_FILTER = { id: 'group', value: ['primary'] };
